var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-skeleton-wrapper',[_c('div',{staticClass:"tw-flex tw-flex-col"},[_c('b-skeleton',{key:"fotos",staticClass:"tw-w-full tw-p-4 tw-pt-8",attrs:{"height":"448px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }